export const ADMIN_ROLE = 'admin';
